
<template>
  <div>
    <diagram-element v-bind:showadd="true" v-bind:allownesting="true"  v-bind:showcontrols="true" ref="reportStatistics" @change="statisticsChanged"></diagram-element>
  </div>
</template>

<script>
  export default {
    name: 'statistics-editor',
    components: {
    },
    props: {

    },
    methods:
    {
      setProcedure(procedureid) {        
        this.$refs.reportStatistics.setProcedure(procedureid)
      },
      statisticsChanged() {
        this.$emit("change")
      },
      setData(data) {
        this.$refs.reportStatistics.setData(data)
      },
      getData() {
        return this.$refs.reportStatistics.getData();
      },
      getJsonData() {
        return this.$refs.reportStatistics.getJsonData();
      },
      handleRefresh() {
      }

    },
    computed: {
      
    },
    created() {
      //this.$root.$on('procedure_refresh', this.handleRefresh);
    },
    mounted() {
     
    },
    computed: {
    },
}
</script>



// WEBPACK FOOTER //
// src/components/statistics/statistics-editor.vue